import StoreModuleService from '../../../StoreModuleService';
import { MODULE_NAME } from './const';
import api from '@/api';
import { SET_WIDGET_MAPPING_SOURCE } from './mutations';
import { getConfigurationFieldResponse } from '../../../workflowConfigurations/getters';
import { saveConfigurationFieldResponse } from '../../../workflowConfigurations/actions';
import { getWidgetFieldData } from '@/store/modules/widgets/getters';
import { configurationsValuesByFieldUUID } from '@/store/modules/configurationEditor/getters';
const buildSelectedWorkflowMapperActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getSourceForMappingsInMapper = buildSelectedWorkflowMapperActionObject('getSourceForMappingsInMapper');
export const saveMappingsInResponse = buildSelectedWorkflowMapperActionObject('saveMappingsInResponse');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getSourceForMappingsInMapper.action]({ commit, rootGetters }, payload) {
		const { widgetFieldUUID, sourceActionString, searchString, workflowVersionId, overrideParamsMap } = payload;

		const credentialsSourceFieldUUID =
			rootGetters[getWidgetFieldData.fullPath](widgetFieldUUID)?.widgetField?.metadata?.source?.credentials_configuration
				?.source_field_uuid;

		const credentials = rootGetters[configurationsValuesByFieldUUID.fullPath][credentialsSourceFieldUUID] || payload.credentials;

		const res = await api.getOptionsForWidget(
			widgetFieldUUID,
			sourceActionString,
			searchString,
			null, //param_key,
			0, //page,
			null, //retrievalId,
			workflowVersionId,
			credentials,
			overrideParamsMap
		);
		const results = res?.results || [];

		commit(SET_WIDGET_MAPPING_SOURCE, { fieldUUID: widgetFieldUUID, sourceMappings: results });
	},
	async [saveMappingsInResponse.action]({ dispatch, rootGetters }, payload) {
		const { value, remove, configurationId, interfaceUUID, widgetFieldUUID } = payload;
		const saveResponse = { ...(rootGetters[getConfigurationFieldResponse.fullPath](configurationId, widgetFieldUUID) || {}) };
		// we should have the response at this point because of the creation data but we will check just to be sure we done break
		if (remove) {
			if (saveResponse.mappings) {
				saveResponse.mappings = saveResponse.mappings.filter((x) => x.originalKey !== value.originalKey);
			}
		} else {
			const mapValue = { ...value, userKey: value.originalKey };
			if (saveResponse.mappings) {
				// updating the value
				saveResponse.mappings = saveResponse.mappings.filter((x) => x.originalKey !== value.originalKey);
				saveResponse.mappings.push(mapValue);
			} else {
				saveResponse.mappings = [mapValue];
			}
		}
		await dispatch(
			saveConfigurationFieldResponse.fullPath,
			{ id: configurationId, interfaceUUID, fieldUUID: widgetFieldUUID, response: saveResponse },
			{ root: true }
		);
	},
};

export default actions;
